import {
  ClipboardCheck, Wrench, Building2, PaintRoller, Home, Palmtree, Sofa, Ruler,
  Sparkles, Truck, Banknote, Calculator, Scale, Shield, Trees, Lamp, Landmark,
  Grid2x2, CheckCircle2, BadgeCheck,
} from "lucide-react";

const ICONS = {
  "clipboard-check": ClipboardCheck, wrench: Wrench, "building-2": Building2,
  "paint-roller": PaintRoller, home: Home, palmtree: Palmtree, sofa: Sofa,
  ruler: Ruler, sparkles: Sparkles, truck: Truck, banknote: Banknote,
  calculator: Calculator, scale: Scale, shield: Shield, trees: Trees,
  lamp: Lamp, landmark: Landmark, grid: Grid2x2,
};

export const CategoryIcon = ({ name, ...props }) => {
  const Cmp = ICONS[name] || Wrench;
  return <Cmp {...props} />;
};

export const LicenceBadge = ({ date, className = "" }) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full bg-[#E8F5F1] text-[#007F83] text-xs font-semibold px-3 py-1 ${className}`}
    data-testid="licence-checked-badge"
    title={`Trade licence checked${date ? " on " + new Date(date).toLocaleDateString() : ""}. We confirm the licence document is readable and matches the stated legal identity and activities. This is not a guarantee of service quality, insurance or government endorsement.`}
  >
    <BadgeCheck size={14} /> Licence checked
  </span>
);

export const SponsoredTag = () => (
  <span className="inline-flex items-center gap-1 rounded-full bg-[#0B1733]/5 text-[#0B1733]/70 text-[11px] font-semibold px-2.5 py-0.5" data-testid="sponsored-tag" title="Paid placement. Promotion is separate from licence checks and review scores.">
    Featured placement
  </span>
);

export const SectionHeader = ({ eyebrow, title, action, actionTo }) => (
  <div className="flex items-end justify-between gap-4 mb-7">
    <div>
      {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#007F83] mb-2">{eyebrow}</p>}
      <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl text-[#0B1733]">{title}</h2>
    </div>
    {action && actionTo && (
      <a href={actionTo} className="hidden sm:inline-flex shrink-0 text-[#007F83] font-semibold hover:text-[#006B70] transition-colors text-sm">
        {action} →
      </a>
    )}
  </div>
);

export const Spinner = ({ label }) => (
  <div className="min-h-[40vh] flex flex-col items-center justify-center gap-3" data-testid="loading-spinner">
    <div className="w-8 h-8 border-2 border-[#007F83] border-t-transparent rounded-full animate-spin" />
    {label && <p className="text-sm text-[#4A5568]">{label}</p>}
  </div>
);

export const EmptyState = ({ title, subtitle, children }) => (
  <div className="text-center py-16 px-6 rounded-2xl border border-dashed border-[#E3E8E8] bg-white" data-testid="empty-state">
    <h3 className="font-display font-bold text-xl text-[#0B1733]">{title}</h3>
    {subtitle && <p className="mt-2 text-sm text-[#4A5568] max-w-md mx-auto">{subtitle}</p>}
    {children && <div className="mt-5">{children}</div>}
  </div>
);

export const Stars = ({ value }) => {
  if (!value) return <span className="text-xs text-[#4A5568]">No reviews yet</span>;
  return (
    <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#0B1733]">
      <CheckCircle2 size={14} className="text-[#007F83]" /> {value.toFixed(1)}
    </span>
  );
};
